import { ReactElement } from 'react';
import { Table, TableProps } from '@ohpen/enso-ui';

import { AssistantRow } from '../brokerCRConfig';

type AssistantsCRProps = { tableProps: TableProps<AssistantRow> };

export const AssistantsCR = ({ tableProps }: AssistantsCRProps): ReactElement => {
  return <Table {...tableProps} />;
};
